export function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, {[key]: {}});
                mergeDeep(target[key], source[key]);
            } else if( Array.isArray(source[key]) ) {

                if( target[key]) {
                    //if (target[key].length > source[key].length) {
                    //target[key] = target[key].map(obj => source[key].find(o => o.id === obj.id) || obj);
                    //} else {
                    //    target[key] = source[key].map(obj => target[key].find(o => o.id === obj.id) || obj);
                    //}

                    source[key].map(obj => {
                        let ooo = target[key].find(o => o.id === obj.id)
                        if(ooo) {
                            let idx = target[key].indexOf(ooo)
                            target[key][idx] = obj
                        } else {
                            target[key].push(obj);
                        }
                    });
                } else {
                    target[key] = source[key];
                }

            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

Object.filter = (obj, predicate) =>
    Object.keys(obj)
        .filter( key => predicate(obj[key]) )
        .reduce( (res, key) => (res[key] = obj[key], res), {} );
